import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../components/button";
import Loader from "../../components/loader";
import NumberInput from "../../components/numberInput/numberInput";
import { openPopUp } from "../../components/popUp";
import { useSafeNavigate } from "../../components/unloadBlocker";
import { useAppContext } from "../../context/appContext";
import { VerifyEmailResponseDTO } from "../../openapi-generated-client";
import SuccessPopUp from "../../pageparts/popup/successPopUp";

interface VerifyEmailProps {
    id: number;
}

export default function VerifyEmail(props:VerifyEmailProps) {

    const {accountController} = useAppContext();

    const [timeToWait, setTimeToWait] = useState(0);
    const [data, setData] = useState<VerifyEmailResponseDTO>();

    const [code, setCode] = useState(0);

    const navigate = useSafeNavigate(useNavigate());


    function updateTimeToWait(newTime: number) {
        setTimeToWait(newTime);
        setTimeout(() => {
            if(newTime <= 0) return;
            updateTimeToWait(newTime-1);
        }, 1000);
    }

    if(props.id != undefined && isNaN(Number(props.id))) {
        window.location.href = "/error/2";
    }

    async function fetchData() {
        try {
            setData((await accountController.sendVerificationMail(Number(props.id))).data);
        } catch(error: any) {
            if(error.status == 425) {
                updateTimeToWait(error.response.data.details);
            }else {
                console.log("Couldnot fetch data for email verification:", error);
            }
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    const sendCode = async (code: number) => {
        accountController.verifyEmail(data?.accountId ? data?.accountId : Number(props.id), {
            code: code
        }).then(() => {
            if(props.id) {
                navigate("/login/registerSuccess");
            }else {
                openPopUp(<SuccessPopUp message="Email changed successfully!"/>);
            }
        }).catch((error: any) => {
            window.dispatchEvent(new Event("clearNumberInput"));
        });
    }

    if(data == undefined) {
        return <Loader/>;
    }

    return <><div className="header column">
            <h1>Please Verify Your Email</h1>
            <p>We have sent you a verification code to <a className="no-hover">{data.email}</a></p>
        </div>
        <div className="content">
            <div className="input">
                <span>Enter code</span>
                <NumberInput length={6} onFinish={sendCode}/>
            </div>
            <Button onClick={() => {
                sendCode(code);
            }}>Continue</Button>

            <div className="bottom bottom-div disabled">
                <p>Didn't receive code? <a className={timeToWait > 0 ? "disabled" : ""} onClick={() => {
                    fetchData();
                }}>Send again{timeToWait > 0 ? " in " + timeToWait : ""}</a></p>
                <p>Wrong email? <a onClick={() => {
                    navigate("/signup/changeEmail/" + data.accountId);
                }}>Change email</a></p>
            </div>
        </div></>;

    

}

export function VerifyEmailPage() {
    const {id} = useParams();
    if(isNaN(Number(id))) {
        window.location.href = "/error/2";
    }
    return <div className="login-box page no-footer open-spacing">
        <VerifyEmail id={Number(id)}/>
    </div>;;
}